// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3BUX6","sendOtp":"AuthorizeToLogin_sendOtp__qPD9l"};